import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ClientService } from '../services/client.service';
import { ScreeningService } from '../services/screening.service';
import { Screening } from '../models/screeningInvite';
import { ApplicantDataService } from '../services/applicant-data.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ScreeningLog, LogParserType } from '../models/LogEntry';

@Component({
  selector: 'app-applicant-review-base',
  templateUrl: './applicant-review-base.component.html',
  styleUrls: ['./applicant-review-base.component.less']
})
export class ApplicantReviewBaseComponent implements OnInit {
  token : string;
  screening : Screening;
  password :string;
  confirmed : boolean = false;
  releasing : boolean = false;
  showReleaseButton : boolean = true;
  constructor(public date : DatePipe,public location: Router, public activatedRoute: ActivatedRoute, public auth: AuthService, public clientSrv: ClientService, public screenings : ScreeningService, public applicantData : ApplicantDataService, public toast : ToastrService) {
    this.auth.titleBarText = "Report Summary"
  }

  gotoSection(route: string){
    this.location.navigateByUrl(route);
  }

  public get ssnYears() : Array<string> {
    if(this.applicantData.ssnRecords){
     if(this.applicantData.ssnRecords.ssnYear.indexOf("-") > 0)
     {
       let years = this.applicantData.ssnRecords.ssnYear.split("-")
       return years
     }else{
       return new Array<string>()[this.applicantData.ssnRecords.ssnYear];
       this.applicantData.screeningInvite.applicantReview
     }
    }
   }

  ngOnInit() {
  }

  confirmAndRelease(){
    this.confirmed = true;
    this.releaseReport();
  }

  releaseReport(){
    this.releasing = true;
    this.showReleaseButton = false;
    if(!this.confirmed) return;
    this.screenings.ReleaseReport(this.applicantData.token).subscribe(
      (scc: boolean)=>{
        // this.toast.success('Your results have been released. You can close this window.', '', {timeOut:5000})
        // this.showReleaseButton = false;
        this.location.navigateByUrl('/review-report');
      },
      (err : any)=>{
        this.toast.error('An error occured while releasing your results.')
        this.showReleaseButton = true;
      }
    )
  }

}
